import {Messages} from "../Messages";
import {WalletPaymentCardIcon} from "../../core/ui/SVGElements.jsx";
import {UI} from "../../stem-core/ui/UIBase";
import {styleRule} from "../../stem-core/decorators/Style";
import {registerStyle} from "../../stem-core/ui/style/Theme";
import {StyleSheet} from "../../stem-core/ui/Style";


class UsingBlinkDefaultPaymentMethodStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        alignItems: "center",
    };

    @styleRule
    icon = {
        display: "inline-block",
        marginRight: 14,
    };
}

// TODO @mustfix This looks like it needs to be removed
@registerStyle(UsingBlinkDefaultPaymentMethodStyle)
export class UsingBlinkDefaultPaymentMethod extends UI.Element {
    render() {
        const {styleSheet} = this;

        return [
            <WalletPaymentCardIcon className={styleSheet.icon}/>,
            Messages.usingBlinkDefault,
        ];
    }
}
